import { Component, OnInit } from "@angular/core";
import { NavController, IonicModule } from "@ionic/angular";
import { Plugins } from "@capacitor/core";
import { CashOutRepositoryService } from "src/app/pages/cashout/cash-out-repository.service";
import { AuthService } from "@core/auth.service";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { CommonVariable } from "src/app/app.constants";
import { HeaderComponent } from "../../header/header.component";
import { NgClass, AsyncPipe } from "@angular/common";
import { DisplayCurrencyPipe } from "../../../pipe/display-currency.pipe";
import { CapitalizeFirstPipe } from "../../../pipe/capitalize-first";
const { Browser } = Plugins;

@Component({
    selector: "app-cashout-status",
    templateUrl: "./cashout-status.component.html",
    styleUrls: ["./cashout-status.component.scss"],
    standalone: true,
    imports: [
        HeaderComponent,
        IonicModule,
        NgClass,
        AsyncPipe,
        DisplayCurrencyPipe,
        CapitalizeFirstPipe,
        TranslatePipe,
    ],
})
export class CashoutStatusComponent implements OnInit {
  pageTitle = "Withdrawal History";
  public isCashOutTransaction: boolean = true;

  cashOutData$ = this.cashOutService.getCashOutStatus();
  preferredCurrency: string = CommonVariable.preferredCurrency
  currencySymbol: string = CommonVariable.defaultCurrencySymbol;
  isPayPalCurrencyINR = false;
  paypalCurrencySymbol: string = CommonVariable.defaultCurrencySymbol;
  constructor(
    private navCtrl: NavController,
    private cashOutService: CashOutRepositoryService,
    public translate: TranslateService,
    private authService: AuthService
  ) {
    this.authService?.selectedlanguage$?.subscribe((l) => {
      if (l) {
        translate.use(l ? l : "en");
      }
    });
    this.authService?.userDetails$?.subscribe({
      next: (user) => {
        this.preferredCurrency = user?.preferred_currency ?? CommonVariable.preferredCurrency;
        this.isPayPalCurrencyINR = this.preferredCurrency === "INR";
        this.authService?.getCurrencyList$?.subscribe((data: any) => {
          const CurrencyDetails = data?.details?.find((x: any) => x?.currency_code === this.preferredCurrency);
          this.currencySymbol = CurrencyDetails?.currency_symbol ?? CommonVariable.defaultCurrencySymbol;
        });
      },
      error: (err) => {
        return err;
      },
    });
  }

  ngOnInit() {
    this.translate.get(["cashout-status.pageTitle"])?.subscribe((res: string) => {
      this.pageTitle = res["cashout-status.pageTitle"];
    });
  }

  goBack() {
    this.navCtrl.back();
  }

  async openInAppBrowser(urlData: string) {
    if (Browser) {
      await Browser.open({ url: urlData });
      window.open(urlData);
    }
  }

  getTranslatedText(statusText: string) {
    const translated = this.cashOutService.getTranslatedStatus(statusText);
    return translated;
  }
}
